import React from "react";
import YearsInBusiness from "./experience-components/YearsInBusiness";
import LicenseList from "./experience-components/LicenseList";
import CertificateList from "./experience-components/CertificateList";
import "../../../../css/freelancer-experience.css";
import { useProfileItems } from "./experience-components/useProfileItems";
import { fetchLicenses, fetchCertificates } from "../../../../services/experienceService";

const BusinessExperience = ({ data }) => {
    const { items: licenses, loading: licensesLoading } = useProfileItems(
        data?.profile?.id,
        fetchLicenses
    );

    const { items: certificates, loading: certsLoading } = useProfileItems(
        data?.profile?.id,
        fetchCertificates
    );

    // // Render nothing until both loaded
    if (licensesLoading || certsLoading) return null;

    return (
        <div className="info-container experience-section">
            <YearsInBusiness initialYears={data?.years_of_experience} />
            <LicenseList profileId={data?.profile?.id} initialLicenses={licenses} />
            <CertificateList profileId={data?.profile?.id} initialCertificates={certificates} />
        </div>
    );
};

export default BusinessExperience;